import React from 'react'
import styled from "styled-components"
import { UseFormRegisterReturn, FieldValues, Path } from 'react-hook-form'

import { FieldWrapper, validationRules } from '..'
import { TextInputFieldProps } from './TextInputField.types'
import { TextInput } from '../../../ui-elements/TextInput'

import { styleTheme } from "../../../../style/theme";

export const TextInputField = <TFormValues extends Record<string, unknown> = Record<string, unknown>>(
  props: TextInputFieldProps<TFormValues>
) => {
  const {
    type = 'text',
    label,
    name,
    register,
    required,
    maxLength,
    minLength,
    pattern,
    validate,
  } = props

  return (
    // @ts-expect-error TS2769 ref: https://taian.atlassian.net/browse/OIM-990
    <StyledComponent
      {...props}
      type={type}
      registration={{...register(name, {
        required: required && validationRules.required(label),
        maxLength: (maxLength || maxLength === 0) ? validationRules.maxLength(maxLength) : undefined,
        minLength: (minLength || minLength === 0) ? validationRules.minLength(minLength) : undefined,
        pattern: pattern && validationRules.pattern[pattern](label),
        validate: validate
      })}}
    />
  )
}

type ComponentProps<TFormValues extends FieldValues> = Omit<TextInputFieldProps<TFormValues>, 'register'> & {
  className?: string
  registration: Partial<UseFormRegisterReturn<Path<TFormValues>>>
}

const Component = <TFormValues extends Record<string, unknown>>(
  props: ComponentProps<TFormValues>
) => (
  <FieldWrapper
    label={props.label}
    error={props.error}
    isRequired={props.required}
    column={props.column}
    labelClassName={props.labelClassName}
    fieldClassName={props.fieldClassName}
  >
    <TextInput
      {...props.registration}
      className={`${props.className}__input ${props.error ? 'error' : ''}`}
      type={props.type}
      placeholder={props.placeholder}
      disabled={props.disabled}
      readOnly={props.readonly}
      defaultValue={props.defaultValue}
      onClick={props.onClick}
    />
  </FieldWrapper>
)
const StyledComponent = styled(Component)`
  &__input {
    background: ${styleTheme.colors.white};
    width: auto;

    &.error {
      border: 1px solid ${styleTheme.colors.pink.base};
    }
  }
`